import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router'

import OversightLeftNav from '../components/OversightLeftNav'
import AuditList from '../components/AuditList'
import Audit from '../components/Audit'
import AuditSearchContainer from './AuditSearchContainer'
import AddEditAuditContainer from './AddEditAuditContainer'
import Authorize from 'app/components/Authorize'
import FourOhFourFallback from 'app/components/FourOhFourFallback'
import { getActiveAudits } from '../actions/searchAuditsAction'

import '../style/audit.scss'

const OversightWorkspace = ({ user, auditList, activeAudits, location, getActiveAudits, searchWasPerformed }) => {
  useEffect(() => {
    if (user.id !== null) {
      getActiveAudits()
    }
  }, [getActiveAudits, user.id])

  const canEditAudit = user.authorizations.some(auth => auth === 'Edit QA Audit File' || auth === 'Edit MU Audit File')
  const canCreateAudit = user.authorizations.some(auth => auth === 'Create QA Audit File' || auth === 'Create MU Audit File')
  const canViewActiveAudits = user.authorizations.includes('View Active Audits Table')

  return <div className='oversight-workspace usa-grid'>
    <Authorize gearAuth={['View Oversight Gear']} gearName='the Oversight Workspace'>
      <div className='usa-width-one-fourth oversight-workspace-leftnav'>
        <OversightLeftNav location={location} canCreateAudit={canCreateAudit} canViewActiveAudits={canViewActiveAudits} />
      </div>
      <div className='usa-width-three-fourths oversight-workspace-main'>
        <Switch>
          {canViewActiveAudits && <Route exact path='/lgyhub/oversight' render={() => <AuditList {...activeAudits} />} />}
          {!canViewActiveAudits && <Route exact path='/lgyhub/oversight' render={() => <Redirect to='/lgyhub/oversight/search' />} />}
          {searchWasPerformed && <Route exact path='/lgyhub/oversight/audits' render={() => <Redirect to='/lgyhub/oversight/search' />} />}
          <Route exact path='/lgyhub/oversight/audits' render={() => <Redirect to='/lgyhub/oversight' />} />
          <Route exact path='/lgyhub/oversight/search' component={AuditSearchContainer} />
          {canCreateAudit && <Route exact path='/lgyhub/oversight/create' component={AddEditAuditContainer} />}
          {canEditAudit && <Route exact path='/lgyhub/oversight/audits/:auditId/edit' render={({ match }) =>
            <AddEditAuditContainer match={match} getActiveAudits={getActiveAudits} audits={auditList} />} />}
          <Route exact path='/lgyhub/oversight/audits/:auditId' render={({ match, history }) =>
            <Audit match={match} history={history} canEditAudit={canEditAudit} />} />
          <Route component={FourOhFourFallback} />
        </Switch>
      </div>
    </Authorize>
  </div>
}

const mapStateToProps = state => ({
  user: state.currentUser,
  activeAudits: state.oversight.activeAudits,
  // TODO: there is probably a less confusing way to do this, see defect 1079633
  auditList: state.oversight.activeAudits.list ?
    state.oversight.activeAudits.list.concat(state.oversight.auditSearch.audit ?
      state.oversight.auditSearch.audit : state.oversight.auditSearch.list ? state.oversight.auditSearch.list : []) : [],
  searchWasPerformed: state.oversight.auditSearch.list
})

const mapDispatchToProps = { getActiveAudits }

export default connect(mapStateToProps, mapDispatchToProps)(OversightWorkspace)